/**
 * Request header that tells ErrorInterceptor not to show its generic error alert because the
 * caller renders the error itself (e.g. inline upload errors). The interceptor strips it before
 * the request leaves the browser.
 */
export const SILENT_ERROR_HEADER = 'X-Silent-Error';
